var _circle, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewShareholdersList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 10,
    r: 9.5,
    fill: "white",
    stroke: "black"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0469 12.4478H9.25977L8.88623 5.29199H11.4204L11.0469 12.4478ZM8.85693 14.9526C8.85693 14.5425 8.9668 14.2324 9.18652 14.0225C9.40625 13.8125 9.72607 13.7075 10.146 13.7075C10.5513 13.7075 10.8638 13.8149 11.0835 14.0298C11.3081 14.2446 11.4204 14.5522 11.4204 14.9526C11.4204 15.3384 11.3081 15.6436 11.0835 15.8682C10.8589 16.0879 10.5464 16.1978 10.146 16.1978C9.73584 16.1978 9.41846 16.0903 9.19385 15.8755C8.96924 15.6558 8.85693 15.3481 8.85693 14.9526Z",
    fill: "#C40F11"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewShareholdersList);
export default __webpack_public_path__ + "static/media/new-shareholders-list.e3068b092f107a062d9057663905b395.svg";
export { ForwardRef as ReactComponent };